import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD6Payload = ({
  eightDInfoId,
  permanentSolution = '',
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  uploadedFiles = [],
  isDisabled = false,
  attachmentsToRemove = [],
  currentUserEmail = getCurrentUserEmail(),
  d6Id = null,
}) => {
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();
  const nowIso = new Date().toISOString();

  const Attachments = (uploadedFiles || []).filter(f => !f.isExisting).map((f) => {
    const base64Data = f.preview || '';
    const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
    return {
      EightDInfoId: finalEightDInfoId,
      AttachmentName: f.file?.name || '',
      AttachmentType: f.file?.type || '',
      AttachmentData: attachmentData,
      CreatedBy: currentUserEmail,
      CreatedOn: nowIso,
    };
  });

  return {
    ...(d6Id ? { D6Id: d6Id } : {}),
    EightDInfoId: finalEightDInfoId,
    PermanentSolution: permanentSolution || '',
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
    ModifiedBy: currentUserEmail,
    ModifiedOn: nowIso,
    IsDisabled: isDisabled,
    Attachments,
    AttachmentsToRemove: attachmentsToRemove || [],
  };
};
